<template>
  <div class="conversation-details">
    <new-messenger-conversation-details-item :title="$t('newMessenger.conversationDetails')">
      <div v-if="$store.state.websocket.loadingTicket" class="collapse-content">
        <b-skeleton />
      </div>
      <div v-else class="collapse-content">
        <div>
          ID: {{ ticket.id }}
        </div>
        <div>
          {{ $t('newMessenger.status') }}: {{ $t(`newMessenger.${ticket.status.toLowerCase()}`) }}
        </div>
        <div v-if="isJoined">
          <div v-if="ticket.status === 'OPEN'" class="content-button">
            <b-button expanded type="is-primary" outlined :loading="$store.state.websocket.loadingCloseTicket" @click="closeTicket()">
              {{ $t('actions.close') }}
            </b-button>
          </div>
          <!-- v-if="!ticket.order" -->
          <div class="content-button">
            <b-button expanded type="is-primary" outlined :loading="$store.state.websocket.loadingChangeOrderId" @click="assignOrderModal = true">
              <span v-if="ticket.order">
                {{ $t('newMessenger.reassignOrder') }}
              </span>
              <span v-else>
                {{ $t('newMessenger.assignOrder') }}
              </span>
              <!-- <span>
                {{ $t('newMessenger.assignOrder') }}
              </span> -->
            </b-button>
          </div>
        </div>
      </div>
    </new-messenger-conversation-details-item>

    <!-- Szczegóły zamówienia -->
    <new-messenger-conversation-details-item v-if="ticket.order" :title="$t('newMessenger.orderDetails')">
      <div v-if="$store.state.websocket.loadingTicket" class="collapse-content">
        <b-skeleton />
      </div>
      <div v-else class="collapse-content">
        <div class="content-orders">
          <new-messenger-conversation-details-order :order="ticket.order" :is-seller="isSeller()" />
        </div>
        <div class="content-button">
          <b-button expanded type="is-primary" outlined @click="seeOrder(ticket.order)">
            {{ $t('newMessenger.seeOrder') }}
          </b-button>
        </div>
      </div>
    </new-messenger-conversation-details-item>

    <!-- Szczegóły produktu -->
    <new-messenger-conversation-details-item v-if="false && ticket.op" :title="$t('newMessenger.productDetails')">
      <div v-if="$store.state.websocket.loadingTicket" class="collapse-content">
        <b-skeleton />
      </div>
      <div v-else class="collapse-content">
        <div class="content-photo">
          <b-image
            ratio="1by1"
            :src="getImageBySize(ticket.op.mainImage.file, 'big').src"
            :webp-fallback="getImageBySize(ticket.op.mainImage.file, 'big').webpFallback"
            :alt="ticket.op.mainImage.name"
            class="skeleton-image-placeholder"
            lazy
          >
            <template #placeholder>
              <b-skeleton />
            </template>
          </b-image>
        </div>
        <div class="content-title">
          {{ ticket.op.description.name }}
        </div>
        <div class="content-price">
          {{ toCurrency(ticket.op.summary.price, '', ticket.op.summary.currency) }}
        </div>
        <div class="content-delivery ">
          <b-icon icon="package-variant" />
          {{ $t('products.shippingInfo.deliveryTime', { time: getDeliveryTime(ticket.op.shippingInfo.deliveryTime) }) }}
        </div>
        <div class="content-button">
          <b-button expanded type="is-primary" outlined @click="seeProduct()">
            {{ $t('newMessenger.seeProduct') }}
          </b-button>
        </div>
      </div>
    </new-messenger-conversation-details-item>

    <!-- Szczegóły o kliencie -->
    <new-messenger-conversation-details-item :title="$t('newMessenger.customerInformation')">
      <div v-if="$store.state.websocket.loadingTicket" class="collapse-content">
        <b-skeleton />
      </div>
      <div v-else class="collapse-content">
        <div class="content-client">
          <div class="content-client-avatar-name">
            <user-avatar
              size="32px"
              :name="ticket.client.name"
              :avatar="ticket.client.avatar"
              :online="ticket.client.online"
            />
            <p class="content-client-name">
              {{ ticket.client.name }}
            </p>
          </div>
          <div class="content-client-data">
            <p>{{ $t('newMessenger.clientJoinedDate') }} {{ $moment(ticket.client.createdAt.date).format('ll') }}</p>
            <p>{{ ticket.client.ordersCount }} {{ $t('newMessenger.orders') }}</p>
            <p>IP: {{ ticket.client.lastIp }}</p>
          </div>
        </div>
        <div class="content-button">
          <b-button expanded type="is-primary" outlined @click="seeClient()">
            {{ $t('newMessenger.seeClient') }}
          </b-button>
        </div>
      </div>
    </new-messenger-conversation-details-item>

    <b-button icon-left="arrow-left" class="conversation-details-icon" @click="emitCloseDetails" />

    <b-modal :active.sync="assignOrderModal" can-cancel width="420px">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('newMessenger.assignOrder') }}
          </p>
          <button
            type="button"
            class="delete"
            @click="assignOrderModal = false"
          />
        </header>
        <section class="modal-card-body">
          <b-field label="ID" :type="errorsAssignOrder ? 'is-danger': ''" :message="errorsAssignOrder ? $t('newMessenger.' + textErrorsAssignOrder): ''">
            <b-input
              v-model="assignOrderId"
              class="error-valid-order"
              placeholder="ID"
            />
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :label="$t('actions.save')"
            type="is-primary"
            :loading="$store.state.websocket.loadingChangeOrderId"
            @click="assignOrder"
          />
          <b-button
            label="Close"
            :loading="$store.state.websocket.loadingChangeOrderId"
            @click="assignOrderModal = false"
          />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import NewMessengerConversationDetailsItem from '../NewMessengerConversationDetailsItem.vue'
import NewMessengerConversationDetailsOrder from '../NewMessengerConversationDetailsOrder.vue'
import UserAvatar from '~/marketplace-front-core/components/shared/UserAvatar'
import toSlugText from '~/marketplace-front-core/utils/toSlugText'

export default {
  name: 'NewMessengerConversationDetails',
  components: {
    NewMessengerConversationDetailsItem,
    NewMessengerConversationDetailsOrder,
    UserAvatar
  },
  props: {
    ticket: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      assignOrderModal: false,
      assignOrderId: null,
      errorsAssignOrder: false,
      textErrorsAssignOrder: '',
      loading: true
    }
  },
  computed: {
    isJoined () {
      const storeAssigned = this.ticket.assignedEmployees.filter(x => x.isMe)
      return !!storeAssigned.length
    }
  },
  watch: {
    assignOrderModal () {
      this.assignOrderId = this.ticket && this.ticket.order ? this.ticket.order.id : null
      this.errorsAssignOrder = false
      this.textErrorsAssignOrder = ''
    }
  },
  methods: {
    isSeller () {
      if (this.user) {
        const check = ['ROLE_SELLER_OWNER', 'ROLE_SELLER'].filter(val =>
          this.user.roles.includes(val)
        )

        return check.length > 0
      }
      return false
    },
    seeClient () {
      const routerPath = this.$router.resolve(this.localePath({ name: 'admin-clients-details', params: { id: this.ticket.client.id } }))
      window.open(routerPath.href, '_blank')
    },
    seeProduct () {
      const routerPath = this.$router.resolve(this.localePath({
        name: 'product',
        params: {
          productName: toSlugText(this.ticket.op.description.name),
          productId: this.ticket.op.id
        }
      }))
      window.open(routerPath.href, '_blank')
    },
    validationAssignOrder (data) {
      if (data !== 'TICKET_UPDATED') {
        this.errorsAssignOrder = true
        this.textErrorsAssignOrder = data
      } else {
        this.textErrorsAssignOrder = ''
        this.errorsAssignOrder = false
        this.assignOrderModal = false
      }
    },
    seeOrder (data) {
      const routerPath = this.$router.resolve(this.localePath({
        name: 'admin-orders-id',
        params: { id: data.id }
      }))
      window.open(routerPath.href, '_blank')
    },
    emitCloseDetails () {
      this.$emit('closeDetails')
    },
    closeTicket () {
      this.$emit('closeTicket')
    },
    getDeliveryTime (deliveryTime) {
      let range = null
      if (deliveryTime) {
        const start = deliveryTime.start
        const end = deliveryTime.end
        if (this.$moment(start).isSame(end, 'year')) {
          if (this.$moment(start).isSame(end, 'month')) {
            if (this.$moment(start).isSame(end, 'day')) {
              range = this.$moment(start).format('dddd, DD MMM')
            } else { range = this.$moment(start).format('DD') + ' - ' + this.$moment(end).format('DD MMM') }
          } else { range = this.$moment(start).format('DD MMM') + ' - ' + this.$moment(end).format('DD MMM') }
        } else { range = this.$moment(start).format('DD.MM.YYYY') + ' - ' + this.$moment(end).format('DD.MM.YYYY') }
      }
      return range
    },
    assignOrder () {
      this.$store.dispatch('websocket/assignOrder', { orderId: this.assignOrderId, ticketId: this.ticket.id })
    }
  }
}
</script>

<style lang="scss" scoped>
$messenger-border-color: #E7E8E7;
$messanger-delivery-color: #179644;
$messanger-content-client-color: #909090;

.card-header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-details {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden auto;

  .collapse-content {
    padding: 16px;

    .content-title {
      margin-top: 16px;
      font-weight: 600;
    }

    .content-photo {
      width: 100%;
    }

    .content-price {
      margin-top: 16px;
      margin-bottom: 8px;
      font-weight: 600;
      font-size: 22px;

      span {
        font-size: 18px;
        font-weight: 300;
      }
    }

    .content-delivery {
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      color: $messanger-delivery-color;
      gap: 0 10px;
    }

    .content-client {
      .content-client-avatar-name {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .content-client-data {
        margin-top: 12px;
        font-size: 14px;
        color: $messanger-content-client-color ;
      }
    }

    .content-button {
      margin: 10px 0;
    }
  }

  .conversation-details-icon {
    position: fixed;
    bottom: 40px;
    left: calc(50% - 20px);
    display: none;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    z-index: 10;

    @include touch {
      display: inline-flex;
    }

    :deep(.icon)>i {
      font-size: 18px !important;
    }
  }
}
</style>
